import {
  DEFAULT_SPEC,
  VISIBLE_SPECS,
  LOAD_INDEX, SIZE,
  SPEED_RATING,
  PRODUCT_DETAIL
} from './constants'

const getSpecValue = (spec, name) =>
  (spec.find(({ specName }) => specName === name) || DEFAULT_SPEC).specValue

export const getProductDetailCell = spec => `
  ${getSpecValue(spec, SIZE)}
  ${getSpecValue(spec, LOAD_INDEX)}${getSpecValue(spec, SPEED_RATING)}
`
export const getCells = specs => specs.reduce((acc, { specName, specValue }) => ({
  ...acc,
  [specName]: specValue
}), {})

export const getFilteredTireSpecifications = (tireSpecifications) =>
  tireSpecifications.map(({ specificationDetailsArray }) => ({
    cells: {
      [PRODUCT_DETAIL]: getProductDetailCell(specificationDetailsArray),
      ...getCells(
        specificationDetailsArray.filter(({ specName }) =>
          VISIBLE_SPECS.includes(specName))
      )
    }
  }))

export const filterVisibleSpecs = (tireSpecifications) =>
  VISIBLE_SPECS.filter(spec => tireSpecifications.every(({ cells }) => cells[spec]))
